import APP from 'src/main.js'
import AppRecord from './AppRecord.js'
class DocumentGroup extends AppRecord {
  get document_groups(){
    return this.constructor.employeeStore.document_groups
  }
  get children(){
    if((this.children_ids||[]).length > 0){
      return this.document_groups.filter(dg => this.children_ids.includes(dg.id))
    } else {
      return []
    }
  }

  get importDescription(){
    const controller = this.constructor.employeeStore.routes.find((x) => x.item_name === 'document_group')

    if (controller){
      const backEndEnum = controller.enums.find((y) => y.name === 'import_type')
      if (backEndEnum){
        const importDescription = backEndEnum.values.find(x => x.id === this.import_type)
        if (importDescription && importDescription.description){
          return importDescription.description.replaceAll('**', '\n')
        }
      }
    }

    return null
  }
}
export default DocumentGroup
